import { Component, OnInit } from '@angular/core';
import { SearchTermservice } from '../../services/search/search-service.service';
import { ParDashboardService } from '../../services/par-dashboard/par-dashboard.service';
import { AgentDashboardService } from '../../services/agent_dashboard/agent-dashboard.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { PageEvent } from '@angular/material';
import { MatPaginatorIntl } from '@angular/material';
import { ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TitleCasePipe } from '@angular/common';
import * as moment from 'moment';


@Component({
  selector: 'app-par-dashboard',
  templateUrl: './par-dashboard.component.html',
  styleUrls: ['./par-dashboard.component.css']
})
export class ParDashboardComponent implements OnInit {
  public agentId: any;
  public agentDetails: any;
  additionalInfo: FormGroup;
  submitSuccess;
  message;
  docsList: any;
  listOfDocs: any = [];
  length: any;
  pageSize = 10;
  isRed: boolean = false;
  isBlue: boolean = false;
  style: any;
  todayDate: any;
  ispaginationFlag: boolean = false;
  DocTypeErrMsg: any;
  DocTypeErr: any;
  noResults: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns = ['DocumentName', 'DocType', 'ExpirationDate'];
  dataSource: MatTableDataSource<UserData>;
  constructor(private router: Router, private parDashboardService: ParDashboardService,
    private route: ActivatedRoute, private searchTermservice: SearchTermservice, private agentDashboardService: AgentDashboardService) { }

  ngOnInit() {
    this.getDocDetails();
    this.parDashboardService.load.subscribe(res => {
      if (res === 'success') {
        this.getDocDetails();
      }
    });
  }

  getDocDetails() {
    this.parDashboardService.getParVendorDetails().subscribe(res => {
      if (res.Documents !== undefined && res.Documents.length <= 0) {
        this.ispaginationFlag = false;
        this.dataSource = null;
        this.noResults = "No documents found";
      } else {
        this.docsList = res;
        this.listOfDocs = this.docsList.Documents;
        for (let i = 0; i < this.listOfDocs.length; i++) {
          if (this.listOfDocs[i].ExpirationDate !== '' && this.listOfDocs[i].ExpirationDate !== null && this.listOfDocs[i].ExpirationDate !== undefined) {
            var momentDate = moment(this.listOfDocs[i].ExpirationDate).format('YYYY/MM/DD');
            this.listOfDocs[i].ExpirationDate = momentDate;
          }
        }
        this.dataSource = new MatTableDataSource(this.listOfDocs);
        this.dataSource.sort = this.sort;
        this.length = this.listOfDocs.length;
        if (this.length <= 10) {
          this.ispaginationFlag = false;
        }
        else {
          this.ispaginationFlag = true;
        }
        if (this.paginator.pageIndex > 0 && (this.length % 10 == 0)) {
          this.paginator.pageIndex = this.paginator.pageIndex - 1;
        }
        this.dataSource.paginator = this.paginator;
        const paginatorIntl = new MatPaginatorIntl();
        paginatorIntl.itemsPerPageLabel = 'Items per page';
        paginatorIntl.nextPageLabel = 'Next page';
        paginatorIntl.previousPageLabel = 'Previous page';
        paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
          length = this.length;
          if (length == 0 || pageSize == 0) { return `0 van ${length}`; }
          length = Math.max(length, 0);
          const startIndex = page * pageSize;
          // If the start index exceeds the list length, do not try and fix the end index to the end.
          const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
          const round = Math.ceil(length / 10)
          return `${(startIndex / 10) + 1}  of ${round}`;
        }
        this.dataSource.paginator._intl = paginatorIntl;
      }
    }, err => {
      this.DocTypeErrMsg = 'PAR Dashboard Service' + ' ' + err;
      this.DocTypeErr = true;
    });
  }

  convertToDocType(DocType) {
    let res = DocType.split("PAR");
    let str = res[1].split("-");
    if (res[1] === 'EMPLOYEE') {
      return 'Employee';
    }
    switch (str[0]) {
      case ("DUEDILIGENCE"):
        return 'Due Diligence';
      case ("INSURANCE"):
        return 'Insurance';
      case ("EMPLOYEE"):
        return 'Employee' + '-' + str[1];
      case ("LICENSE"):
        return 'License';
    }
  }

  getColor(expirationDate) {
    let todayDate = new Date()
    let currentDate = new Date().setHours(0, 0, 0, 0);
    var targetDate = new Date();
    let futureDate = targetDate.setDate(todayDate.getDate() + 30);
    let future = new Date(futureDate).setHours(0, 0, 0, 0);
    let expDate = new Date(expirationDate).setHours(0, 0, 0, 0);
    if (expDate < currentDate) {
      return "red";
    }
    else if (expDate > future) {
      return "black";
    }
    else {
      return "blue";
    }
  }

  selectedDoc(listOfDocs) {
    let str = listOfDocs.DocType;
    let res = str.split("-");
    let DocType = res[0];
    let id = res[1];
    if (str === "PAREMPLOYEE") {
      this.router.navigate(['par/employee', 'Documents', id]);
    }
    switch (DocType) {
      case ("PARDUEDILIGENCE"):
        this.router.navigate(['par/duediligence', DocType]);
        break;
      case ("PAREMPLOYEE"):
        if (id !== undefined) {
          localStorage.setItem('ParEmployeeID', id);
          localStorage.setItem('dbId', listOfDocs._id !== undefined ? listOfDocs._id : '');
          this.router.navigate(['par/employee', 'Documents', id]);
        } else {
          this.router.navigate(['par/employee', DocType]);
        }
        break;
      case ("PARLICENSE"):
        this.router.navigate(['par/license', DocType]);
        break;
      case ("SUMMARY"):
        this.router.navigate(['par/summary', DocType]);
        break;
      case ("PARINSURANCE"):
        this.router.navigate(['par/insurance', DocType]);
        break;
    }
  }
}
export interface UserData {
  DocumentName: String;
  DocType: String;
  ExpirationDate: Date;
}



// WEBPACK FOOTER //
// ./src/app/components/par-dashboard/par-dashboard.component.ts